module.exports = __webpack_public_path__ + "icn_arrow_down_blue.bac5ba423e9b8a0996de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icn_arrow_down_blue.png
// module id = 222
// module chunks = 0